import { Routes } from '@angular/router';

import { ApplicationPage } from '@advania-cosoftware/wolf-legacy';
import { applicationsSegments } from '@advania-cosoftware/wolf-router';

export const applicationsRoutes: Routes = [
    {
        path: applicationsSegments.applications,
        loadComponent: () =>
            import('./features/home/applications-home/applications-home.page').then((m) => m.ApplicationsHomePage),
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: applicationsSegments.applicationsList,
            },
            {
                path: applicationsSegments.applicationsList,
                loadComponent: () =>
                    import('./features/applications-page/applications.page').then((m) => m.ApplicationsPage),
            },
        ],
    },
    {
        path: `${applicationsSegments.applications}/:applicationId`,
        component: ApplicationPage,
    },
];
